import { render, staticRenderFns } from "./ReInputINN.vue?vue&type=template&id=72da9600&scoped=true"
import script from "./ReInputINN.vue?vue&type=script&lang=js"
export * from "./ReInputINN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da9600",
  null
  
)

export default component.exports